import { UrlApi } from "../../../../../../services/apirest";

// Busca direcciones de las sucursales autorizadas aplicando los filtros elegidos.
export const buscarDireccionesSucAuth = async (sucursales, searchTerm, filtros) => {
  const searchParams = new URLSearchParams({
    search: searchTerm.trim(),
    limit: 100,
    filtros: filtros.join(","),
  });

  const response = await fetch(
    UrlApi +
      `/envasado_direcciones_entrega/buscarDireccionesSucAuth/${sucursales.join(
        ",",
      )}?${searchParams}`,
  );

  if (!response.ok) {
    throw new Error(`Error HTTP: ${response.status}`);
  }

  return response.json();
};

// Direcciones activas del cliente con la misma forma que usa la ficha de
// cliente (incluye idCliente, sucursal y nombre_zona, que pide EdicionDireccionEnv).
export const getDireccionesPorCliente = async (idCliente) => {
  const response = await fetch(UrlApi + `/envasado_direcciones_entrega/cli/${idCliente}`);

  if (!response.ok) {
    throw new Error(`Error HTTP: ${response.status}`);
  }

  return response.json();
};
